
var id = "circleDelete";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"circleDelete\">\n<style type=\"text/css\">\n\t#circleDelete .st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t#circleDelete .st1{}\n</style>\n<g id=\"circleDelete_控件\">\n\t<g id=\"circleDelete_操作\" transform=\"translate(-28.000000, -113.000000)\">\n\t\t<g id=\"circleDelete_删除-default\" transform=\"translate(28.000000, 113.000000)\">\n\t\t\t<g id=\"circleDelete_SVGID_1_-link\" transform=\"translate(4.888800, 4.000000)\">\n\t\t\t\t<path id=\"circleDelete_SVGID_1_\" class=\"st0\" d=\"M4.7,0.4L4.2,0H2L1.6,0.4H0v0.9h6.2V0.4H4.7z M1.5,3.9l0.6-0.6l0.9,0.9l0.9-0.9l0.6,0.6\n\t\t\t\t\tL3.7,4.9l0.9,0.9L4.1,6.5L3.1,5.5L2.2,6.5L1.5,5.8l0.9-0.9L1.5,3.9z M0.4,7.1C0.4,7.6,0.8,8,1.3,8h3.6c0.5,0,0.9-0.4,0.9-0.9\n\t\t\t\t\tV1.8H0.4V7.1z\" />\n\t\t\t</g>\n\t\t\t<path id=\"circleDelete_形状\" class=\"st1\" d=\"M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14.4c-3.5,0-6.4-2.9-6.4-6.4\n\t\t\t\tS4.5,1.6,8,1.6s6.4,2.9,6.4,6.4S11.5,14.4,8,14.4z\" />\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
